var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("v-simple-table", {
        attrs: { dense: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Type")]),
                    _c("th", [_vm._v("In/Out")]),
                    _c("th", [_vm._v("Cheque No.")]),
                    _c("th", [_vm._v("Status")]),
                    _c("th", [_vm._v("Date")]),
                    _c("th", { staticClass: "text-right" }, [_vm._v("Amount")])
                  ])
                ]),
                _c(
                  "tbody",
                  [
                    _vm.voucherTransactionByVoucherGetting
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: { colspan: "3" }
                            },
                            [
                              _c("v-progress-circular", {
                                attrs: {
                                  color: "primary",
                                  indeterminate: "",
                                  size: "30"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._l(_vm.voucherTransactionByVoucherList, function(
                          item
                        ) {
                          return _c("tr", { key: item.id }, [
                            _c(
                              "td",
                              { staticClass: "text-uppercase" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: { color: "yellow darken-2" },
                                    on: {
                                      click: function($event) {
                                        return _vm.$emit("input", item)
                                      }
                                    }
                                  },
                                  [_vm._v("mdi-pencil")]
                                ),
                                _vm._v(_vm._s(item.type))
                              ],
                              1
                            ),
                            _c("td", [
                              _vm._v(_vm._s(item.amount < 0 ? "In" : "Out"))
                            ]),
                            _c("td", [_vm._v(_vm._s(item.cheque_number))]),
                            _c(
                              "td",
                              { class: _vm.statusColor(item) + "--text" },
                              [_vm._v(_vm._s(item.status.description))]
                            ),
                            _c("td", [
                              _vm._v(_vm._s((item.date || "").dateFormat()))
                            ]),
                            _c("td", { staticClass: "text-right" }, [
                              _c(
                                "span",
                                {
                                  class:
                                    item.amount > 0
                                      ? "red--text"
                                      : "green--text"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      Math.abs(item.amount || 0).phpFormat()
                                    )
                                  )
                                ]
                              )
                            ])
                          ])
                        }),
                    _c("tr", [
                      _c("th", { attrs: { colspan: "5" } }, [
                        _vm._v("Voucher Amount")
                      ]),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(_vm._s((_vm.voucherAmount || 0).phpFormat()))
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { colspan: "5" } }, [
                        _vm._v("Total Amount")
                      ]),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(_vm._s((_vm.totalAmount || 0).phpFormat()))
                      ])
                    ]),
                    _c("tr", [
                      _c("th", { attrs: { colspan: "5" } }, [
                        _vm._v("Balance")
                      ]),
                      _c(
                        "td",
                        {
                          class: `text-right ${_vm.balanceNegativeColor}--text`
                        },
                        [_vm._v(_vm._s(_vm.balance.phpFormat()))]
                      )
                    ])
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }